"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var server_1 = require("../../helpers/server");
var SideMenuActions_1 = require("./SideMenuActions");
var redux_persist_1 = require("redux-persist");
var reducers_1 = require("../_shared/reducers");
var initialState = {
    isCollapsed: false,
    lostGpsUserCount: 0,
    selectedCompanyId: null,
    companies: [],
};
exports.default = (function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case (0, server_1.apiActions)(SideMenuActions_1.default.GET_LOST_GPS_COUNT).success: {
            return __assign(__assign({}, state), { lostGpsUserCount: action.payload.count });
        }
        case SideMenuActions_1.default.TOGGLE_SIDE_MENU:
            return __assign(__assign({}, state), { isCollapsed: action.payload.isCollapsed });
        case SideMenuActions_1.default.SET_SELECTED_COMPANY:
            return __assign(__assign({}, state), { selectedCompanyId: action.payload.companyId });
        case (0, server_1.apiActions)(SideMenuActions_1.default.LOAD_COMPANIES).success:
            return __assign(__assign({}, state), { companies: action.payload.companies });
        // The company filter belongs to one session. Reset it so the next user
        // does not inherit it (the persisted state can outlive a logout).
        case (0, server_1.apiActions)(reducers_1.LoginActions.LOGIN).success:
        case reducers_1.LoginActions.LOGOUT:
            return __assign(__assign({}, state), { selectedCompanyId: null });
        case redux_persist_1.PURGE:
            return __assign({}, initialState);
        default:
            return state;
    }
});
